<template lang="html">
  <div class="p-3 p-lg-4" v-if="$store.state.object">

    <div class="fw-700 fs-14 d-flex flex-wrap align-items-center">

      <div class="mr-3 mb-3">
        {{ {ru: 'Выбор объекта', ua: "Вибір об'єкту"}[lang] }}:
      </div>

      <div class="mr-4 mb-3 mw-100 dropdown-objects">
        <b-dropdown
          variant="transparent"
          toggle-class="border-dark fw-700 fs-14 overflow-x-hidden"
          no-caret
          :block="true"
          v-if="$store.state.object.group_name"
          :text="lang === 'ru' ? ($store.state.object.group_name + ': ' + $store.state.object.name) : ($store.state.object.group_name_ua + ': ' + $store.state.object.name_ua)">
          <b-dropdown-item
            v-for="object in $store.state.objects"
            :key="object.id"
            :to="'/objects/' + object.id + '/predict'"
            class="border-bottom">
            <strong>{{ lang === 'ru' ? object.group_name : object.group_name_ua }}</strong><br> {{ lang === 'ru' ? object.name : object.name_ua }}
          </b-dropdown-item>
        </b-dropdown>
      </div>

      <div class="w-100"></div>

      <div class="d-flex align-items-center position-relative">
        <div class="mr-3 mb-3">
          {{ {ru: 'Начало периода', ua: 'Початок періоду'}[lang] }}:
        </div>
        <Datepicker
          v-model="date_from"
          :format="customFormatter"
          @input="setDateFrom"
          :disabled-dates="{
            to: $moment().subtract(1, 'day').toDate()
          }"
          :language="lang === 'ru' ? ru : ua"
          :monday-first="true"
          input-class="form-control bg-transparent border-dark fw-700 fs-14 text-dark mr-4 mb-3"/>
      </div>

      <div class="d-flex align-items-center position-relative">
        <div class="mr-3 mb-3">
          {{ {ru: 'Конец периода', ua: 'Кінець періоду'}[lang] }}:
        </div>

        <Datepicker
          v-model="date_to"
          :format="customFormatter"
          :disabled-dates="{
            to: date_from,
            from: $moment(date_from).add(1, 'month').toDate()
          }"
          :language="lang === 'ru' ? ru : ua"
          :monday-first="true"
          input-class="form-control bg-transparent border-dark fw-700 fs-14 text-dark mr-4 mb-3"/>
      </div>

      <router-link :to="'/objects/' + $store.state.object.id" class="btn btn-success btn-sm ml-3 mb-3">
        {{ lang === 'ru' ? 'К показаниям' : 'До показань' }}
      </router-link>

    </div>

    <b-tabs
      :small="$store.state.vw < 992"
      pills
      content-class="mt-3">
      <b-tab :title="lang === 'ru' ? 'Прогноз' : 'Прогноз'" active>

        <b-table
          v-if="!$store.state.loading"
          id="object-predict-table"
          head-variant="light"
          foot-varian="light"
          responsive
          bordered
          small
          :fields="fields"
          :items="predictedItems">
          <template #cell(serial_number)="data">
            <router-link v-if="data.item.device" :to="'/manager/devices/' + data.item.device.id + '/predict'" class="btn btn-primary btn-sm">
              {{ data.item.device.serial_number }}
            </router-link>
          </template>
          <template #cell(apartment_type)="data">
            {{ {residential: (lang === 'ru' ? 'Жилое' : 'Житлове'), commercial: (lang === 'ru' ? 'Коммерческое' : 'Коммерційне')}[data.item.apartment_type] }}
          </template>
          <template #cell(de_predicted)="data">
            <span v-if="data.item.de_predicted != undefined">
              {{ new Intl.NumberFormat('ua-UA', {minimumFractionDigits: 3}).format(data.item.de_predicted) }}
            </span>
          </template>

          <template #custom-foot>
            <b-tr>
              <b-th colspan="6" class="text-right">{{ lang === 'ru' ? 'Сумма' : 'Сума' }}</b-th>
              <b-th class="text-center">
                <span v-if="totalPredictedDe !== null">
                  {{ new Intl.NumberFormat('ua-UA', {minimumFractionDigits: 3}).format(totalPredictedDe) }}
                </span>
              </b-th>
              <b-th colspan="2"></b-th>
            </b-tr>
          </template>
        </b-table>
      </b-tab>

      <b-tab :title="$store.state.vw < 992 ? 'Q, Гкал' : (lang === 'ru' ? 'График прогноза Q, Гкал' : 'Графік прогнозу Q, Гкал')">
        <div class="h-300-px">
          <apexchart
            v-if="chartData.dates.length > 0"
            type="line"
            :options="getQGraphOptions"
            :key="0"
            :height="300"
            :series="getGraphData">
          </apexchart>
        </div>
        <div class="h-300-px mb-5">
          <apexchart
            v-if="chartData.dates.length > 0"
            type="line"
            :options="getWeatherGraphOptions"
            :key="1"
            :height="300"
            :series="getGraphDataWeather">
          </apexchart>
        </div>
      </b-tab>
    </b-tabs>

  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
const vdp_translation = require('vuejs-datepicker/dist/locale/translations/ru.js')
import vdp_translation_ua from  'vuejs-datepicker/dist/locale/translations/uk'

export default {
  name: 'ObjectPredict',

  components: {
    Datepicker
  },

  data: function () {
    return {
      ru: vdp_translation,
      ua: vdp_translation_ua,
      date_from: this.$moment().toDate(),
      date_to: this.$moment().add(14, 'days').toDate(),
      predictedItems: [],
      chartData: {
        dates: [],
        values: [],
        temperatures: []
      }
    }
  },

  watch:{
    $route (to) {
      this.$store.commit('setData', {
        attr: 'object',
        value: {
          id: to.params.id
        }
      })
      this.updateObjectFromList()
      this.fetchPredictions()
    },
    date_from () {
      this.fetchPredictions()
    },
    date_to () {
      this.fetchPredictions()
    }
  },

  computed: {

    fields () {
      return [
        {
          label: this.lang === 'ru' ? '№ Помещения' : '№ приміщення',
          key: this.lang === 'ru' ? 'apartment_number' : 'apartment_number_ua',
          sortable: true
        },
        {
          label: this.lang === 'ru' ? 'Тип помещения' : 'Тип приміщення',
          key: 'apartment_type',
          sortable: true
        },
        {
          label: this.lang === 'ru' ? 'Код производителя устройства' : 'Код виробника пристрою',
          key: 'device.man',
          sortable: true
        },
        {
          label: this.lang === 'ru' ? 'Серийный номер устройства' : 'Серійний номер пристрою',
          key: 'serial_number',
        },
        {
          label: this.lang === 'ru' ? 'Статус устройства' : 'Статус пристрою',
          key: 'device.status',
          sortable: true
        },
        {
          label: this.lang === 'ru' ? 'Ошибки на устройстве' : 'Помилки на пристрої',
          key: 'device.errors',
          sortable: true
        },
        {
          label: this.lang === 'ru' ? 'ΔQ прогноз (Гкал)' : 'ΔQ прогноз (Гкал)',
          key: 'de_predicted',
          tdClass: 'bg-deep-heat',
          thClass: 'th-w-85',
          sortable: true
        },
        {
          label: this.lang === 'ru' ? 'Средняя температура (°C)' : 'Середня температура (°C)',
          key: 'avg_temperature',
          sortable: true
        },
        {
          label: 'Код прошивки',
          key: 'device.firmware_ver',
          sortable: true
        }
      ]
    },

    lang () {
      return this.$store.state.lang
    },

    totalPredictedDe () {
      if (this.predictedItems.length === 0) return null
      return this.predictedItems.reduce((sum, item) => sum + (item.de_predicted || 0), 0)
    },

    getGraphData () {
      return [{
        name: `Q (прогноз)`,
        data: this.chartData.values
      }]
    },

    getGraphDataWeather () {
      return [{
        name: this.lang === 'ru' ? 'Среднесуточная температура воздуха' : 'Середньодобова температура повітря',
        data: this.chartData.temperatures
      }]
    },

    getQGraphOptions () {
      return {
        chart: {
          id: 'vuechart-q-predict',
          height: '100%'
        },
        colors: ['#fb881e'],
        stroke: {
          curve: 'smooth',
        },
        markers: {
          size: 3,
        },
        xaxis: {
          categories: this.chartData.dates
        }
      }
    },

    getWeatherGraphOptions () {
      return {
        chart: {
          id: 'vuechart-w-predict',
          height: '100%',
        },
        colors: ['#21cc46'],
        stroke: {
          curve: 'smooth',
        },
        markers: {
          size: 3,
        },
        xaxis: {
          categories: this.chartData.dates
        }
      }
    }
  },

  methods: {

    updateObjectFromList () {
      // Update object data from objects list to show dropdown
      if (this.$store.state.objects && this.$store.state.objects.length > 0 && this.$store.state.object.id) {
        const foundObject = this.$store.state.objects.find(obj => obj.id === parseInt(this.$store.state.object.id))
        if (foundObject) {
          this.$store.commit('mergeStore', {
            object: foundObject
          })
        }
      }
    },

    customFormatter (date) {
      return this.$moment(date).format('DD.MM.YYYY');
    },

    setDateFrom () {
      if (
        this.$moment(this.date_to) > this.$moment(this.date_from).add(1, 'month') ||
        this.$moment(this.date_to) < this.$moment(this.date_from)
      ) {
        this.date_to = this.$moment(this.date_from).add(14, 'days').toDate()
      }
    },

    async fetchPredictions () {
      this.$store.commit('mergeStore', {
        loading: true
      })
      this.predictedItems = []
      this.chartData = { dates: [], values: [], temperatures: [] }

      try {
        const dateFrom = this.$moment(this.date_from).format('YYYY-MM-DD')
        const dateTo = this.$moment(this.date_to).format('YYYY-MM-DD')

        // Step 1: Get weather forecast
        const weatherResponse = await this.$http.get('/api/weather/forecast/', {
          params: {
            from: dateFrom,
            to: dateTo
          }
        })

        if (!weatherResponse.data.success) {
          throw new Error(weatherResponse.data.error || 'Failed to load weather')
        }

        const weatherData = weatherResponse.data.data

        // Step 2: Get apartments with devices (no historical data)
        const apartmentsResponse = await this.$http.get(`/api/objects/${this.$store.state.object.id}/apartments-with-devices`)
        const apartments = apartmentsResponse.data || []

        // Step 3: Prepare batch request for all devices
        const devices = []
        const apartmentByDeviceId = {}

        for (const apartment of apartments) {
          if (!apartment.device || !apartment.device.id) continue

          apartmentByDeviceId[apartment.device.id] = apartment

          // Prepare records for this device
          const records = weatherData.map((weather, index) => ({
            id: index,
            date: weather.date,
            temperature: weather.temperature,
            wind_speed: weather.wind_speed,
            wind_direction: weather.wind_direction,
            precipitation: weather.precipitation,
            pressure: weather.pressure,
            humidity: weather.humidity,
            uv_index: weather.uv_index
          }))

          devices.push({
            device_id: apartment.device.id,
            records: records
          })
        }

        if (devices.length === 0) {
          this.predictedItems = []
          this.$store.commit('mergeStore', {
            loading: false
          })
          return
        }

        // Step 4: Get batch predictions
        const predictionResponse = await this.$http.post('/api/mlp/predict/batch-devices/', {
          devices: devices
        })

        if (!predictionResponse.data.success) {
          throw new Error(predictionResponse.data.error || 'Failed to get predictions')
        }

        const predictions = predictionResponse.data.predictions || {}
        const errors = predictionResponse.data.errors || {}

        // Log errors
        for (const deviceId in errors) {
          console.warn(`Prediction error for device ${deviceId}:`, errors[deviceId])
        }

        // Step 5: Build predicted items
        for (const apartment of apartments) {
          if (!apartment.device) continue

          const deviceId = apartment.device.id
          const prediction = predictions[deviceId]

          if (!prediction) continue

          const avgTemperature = weatherData.reduce((sum, w) => sum + w.temperature, 0) / weatherData.length

          this.predictedItems.push({
            ...apartment,
            de_predicted: prediction.total || 0,
            avg_temperature: avgTemperature.toFixed(1)
          })
        }

        // Step 6: Prepare chart data (aggregate by date)
        const dateAggregates = {}
        const dateTemperatures = {}

        for (const weather of weatherData) {
          dateAggregates[weather.date] = 0
          // Store temperature for each date (use forecast temperature if available, otherwise average)
          dateTemperatures[weather.date] = weather.temperature || null
        }

        for (const deviceIdStr in predictions) {
          const devicePredictions = predictions[deviceIdStr].predictions || {}

          for (const index in devicePredictions) {
            const weather = weatherData[parseInt(index)]
            if (weather) {
              dateAggregates[weather.date] += devicePredictions[index] || 0
            }
          }
        }

        // Calculate average temperature if some dates don't have temperature
        const temperatures = Object.values(dateTemperatures).filter(t => t !== null)
        const avgTemp = temperatures.length > 0 
          ? temperatures.reduce((sum, t) => sum + t, 0) / temperatures.length 
          : null

        // Fill missing temperatures with average
        for (const date in dateTemperatures) {
          if (dateTemperatures[date] === null && avgTemp !== null) {
            dateTemperatures[date] = avgTemp
          }
        }

        this.chartData.dates = Object.keys(dateAggregates).map(d => this.$moment(d).format('DD.MM'))
        this.chartData.values = Object.values(dateAggregates).map(v => parseFloat(v.toFixed(3)))
        this.chartData.temperatures = Object.keys(dateAggregates).map(d => {
          const temp = dateTemperatures[d]
          return temp !== null ? parseFloat(temp.toFixed(1)) : null
        })

      } catch (error) {
        console.error('Error fetching predictions:', error)
        this.$toasted.error('Ошибка загрузки прогноза')
      } finally {
        this.$store.commit('mergeStore', {
          loading: false
        })
      }
    }
  },

  async mounted () {
    try {
      this.$store.commit('mergeStore', {
        object: {
          id: this.$route.params.id
        },
        loading: true
      })

      // Load object info without data
      await this.$store.dispatch('getObjects')

      // Update object data from objects list to show dropdown
      this.updateObjectFromList()

      // Fetch predictions
      await this.fetchPredictions()

    } catch (e) {
      this.$toasted.error(`${e.name}: ${e.message}`, {duration: 1000})
    }
  }
}
</script>

<style lang="scss">
.vdp-datepicker{
  input{
    width: 120px;
  }
}
#object-predict-table{
  td{
    text-align: center;
    width: 11.11%;
  }
}

.overflow-x-hidden{
  overflow-x: hidden;
}

.dropdown-objects{
  .btn{
    white-space: pre-wrap;
  }
}
</style>
